// extracted by mini-css-extract-plugin
export var locationCard = "_hi-0";